import React from 'react';
import './PayComponent.scss';
import {setStorageCache, showLogin} from "../../asstes/js/Utils";
import {
	clearUserInfo,
	paySubmitOrder,
	showPassWordModules,
	showTipsAlert,
	showToast
} from "../../asstes/js/IntegratedProcessing";
import Config from "../../asstes/js/Config";

class PayComponent extends React.Component {
	state = {
		// isCheck: false,
		selectMouseIdx: Config.selectMouse, // 当前选择的老鼠
	}

	submit = (e) => {
		e.preventDefault()
		// if (!this.state.isCheck) {
		// 	showToast('请阅读并同意活动规则！')
		// 	return
		// }
		let {payInfo} = this.props
		let productInfo = payInfo.actionObjectList[0]
		paySubmitOrder(productInfo).then(res => {
			// console.log(res);
			if (res.success) {
				console.log(res.datas);
				setStorageCache('submitOrderInfo', res.datas, true)
				let {payStr} = res.datas
				window.location.href = payStr
			} else if (res.errorCode === '5104') {
				this.close()
				showTipsAlert('本活动仅限广东非深圳用户参与哦～', '我知道了')
			} else if (res.errorCode === '5105') { // 查询中行接口失败,请稍后再试
				showTipsAlert('当前参与的用户过多，请稍后再来吧～', '我知道了')
			} else if (res.errorCode === '600') { // 用户校验失败
				clearUserInfo()
				showLogin()
			} else {
				this.close()
				showToast('提交订单失败，请稍后重试！')
			}
		})
	}

	// toggleCheck = () => {
	// 	this.setState({
	// 		isCheck: !this.state.isCheck
	// 	})
	// }

	close = () => {
		this.props.closePayAlert && this.props.closePayAlert()
	}

	showPassWord = () => {
		showPassWordModules()
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const payBtn = require('../../asstes/img/alert/one-pay-btn.png')
		const PayClose = require('../../asstes/img/alert/login-close.png')
		const {selectMouseIdx} = this.state
		const loginTopArr = [
			require('../../asstes/img/Index/gift-list/login-top1.png'),
			require('../../asstes/img/Index/gift-list/login-top2.png'),
			require('../../asstes/img/Index/gift-list/login-top3.png'),
			require('../../asstes/img/Index/gift-list/login-top4.png'),
			require('../../asstes/img/Index/gift-list/login-top5.png'),
			require('../../asstes/img/Index/gift-list/login-top6.png'),
		]

		return <div className="pay-container">
			<p className="prompt"></p>
			<div className="pay-relative">
				<img src={loginBg} alt=""/>
				<div className="pay-container-content">
					<img className="relative-img" src={loginTopArr[selectMouseIdx]} alt=""/>
					<div className="pay-top-text">
						只差一步，就能打开锦盒了，微信红包藏在里面哦!
					</div>
					<div className="pay-btn">
						<a href="/" onClick={this.submit}>
							<img src={payBtn} alt=""/>
						</a>
					</div>
					<div className="pay-description">
						{/*<p className="flex-center-center" onClick={this.toggleCheck}>
							<span className={`check-div flex-center-center ${isIOS() ? '' : 'check-android'}`}>
								{
									isCheck ? <span className="is-check"></span> : null}
							</span>
							本人确认理解并遵守活动规则全部内容
						</p>*/}
						<div className="change-password">
							<p>需使用中行手机银行支付,如忘记支付密码</p>
							<p>请查看此处<span className="change-password-font" onClick={this.showPassWord}>修改密码指引</span></p>
						</div>
					</div>
				</div>
				<div className="login-close flex-center-center">
					<img className="login-close-icon" src={PayClose} onClick={this.close} alt=""/>
				</div>
			</div>
		</div>
	}
}

export default PayComponent;
